import { HttpError } from 'ra-core';
import { SdkHttpError, toHttpError as toSdkHttpError } from '@wwf/sdk';

export function toHttpError(error: unknown): HttpError {
    if (error instanceof HttpError) {
        return error;
    }
    if (error instanceof SdkHttpError) {
        return new HttpError(error.message, error.status, error.body);
    }
    const sdkError = toSdkHttpError(error);
    return new HttpError(sdkError.message, sdkError.status, sdkError.body);
}
